import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Button from '@cloudscape-design/components/button';
import Container from '@cloudscape-design/components/container';
import Form from '@cloudscape-design/components/form';
import FormField from '@cloudscape-design/components/form-field';
import Header from '@cloudscape-design/components/header';
import Input from '@cloudscape-design/components/input';
import SpaceBetween from '@cloudscape-design/components/space-between';
import api from '../services/apiService';
import { setSession } from '../utils/auth';

export default function LoginPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  async function login(event) {
    event.preventDefault();
    setError('');
    setLoading(true);
    try {
      const response = await api.post('/auth/login', { email, password });
      setSession(response.data.token, response.data.user);
      const target = location.state?.from || (response.data.user.role === 'platform_admin' ? '/admin/mandanten' : '/portal');
      navigate(target, { replace: true });
    } catch (requestError) {
      setError(requestError.response?.data?.error || 'Login fehlgeschlagen.');
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="offer-shell">
      <Container>
        <Form
          header={<Header variant="h1" description="Zugang für registrierte Vermieter und Plattformadministratoren">SmartRent Login</Header>}
          errorText={error}
          actions={<Button variant="primary" loading={loading} onClick={login}>Einloggen</Button>}
        >
          <form onSubmit={login}>
            <SpaceBetween size="m">
              <FormField label="E-Mail"><Input type="email" value={email} onChange={({ detail }) => setEmail(detail.value)} /></FormField>
              <FormField label="Passwort"><Input type="password" value={password} onChange={({ detail }) => setPassword(detail.value)} /></FormField>
            </SpaceBetween>
          </form>
        </Form>
      </Container>
    </div>
  );
}

